import React from "react";
import { BrowserRouter, Routes as RouterRoutes, Route } from "react-router-dom";
import LoginPage from "./pages/auth-login";
import ScrollToTop from "components/ScrollToTop";
import ErrorBoundary from "components/ErrorBoundary";
import NotFound from "pages/NotFound";
import PrivateRoute from "components/PrivateRoute";
import AdminPortal from "./pages/admin-portal";
import CreateEvent from "./pages/admin-portal/CreateEvent";
import ManageVolunteers from "./pages/admin-portal/ManageVolunteers";
import SystemReports from "./pages/admin-portal/SystemReports";
import Unauthorized from "./pages/unauthorized";
import SmartOpportunityFinder from './pages/smart-opportunity-finder';
import SkillsDevelopmentAcademy from './pages/skills-development-academy';
import EventExperienceHub from './pages/event-experience-hub';
import OrganizationImpactProfiles from './pages/organization-impact-profiles';
import MissionControlDashboard from './pages/mission-control-dashboard';
import VolunteerJourneyTracker from './pages/volunteer-journey-tracker';

import LandingPage from './pages/landing';

const Routes = () => {
  return (
    <BrowserRouter>
      <ErrorBoundary>
        <ScrollToTop />
        <RouterRoutes>
          {/* Public Routes */}
          <Route path="/" element={<LandingPage />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/unauthorized" element={<Unauthorized />} />

          {/* Protected Portal Routes */}
          <Route
            path="/admin-portal"
            element={
              <PrivateRoute requiredRole="admin">
                <AdminPortal />
              </PrivateRoute>
            }
          />
          <Route
            path="/admin/create-event"
            element={
              <PrivateRoute requiredRole="admin">
                <CreateEvent />
              </PrivateRoute>
            }
          />
          <Route
            path="/admin/manage-volunteers"
            element={
              <PrivateRoute requiredRole="admin">
                <ManageVolunteers />
              </PrivateRoute>
            }
          />
          <Route
            path="/admin/system-reports"
            element={
              <PrivateRoute requiredRole="admin">
                <SystemReports />
              </PrivateRoute>
            }
          />


          {/* Protected Feature Routes */}
          <Route
            path="/mission-control-dashboard"
            element={
              <PrivateRoute requiredRole="volunteer">
                <MissionControlDashboard />
              </PrivateRoute>
            }
          />
          <Route
            path="/volunteer-journey-tracker"
            element={
              <PrivateRoute requiredRole="volunteer">
                <VolunteerJourneyTracker />
              </PrivateRoute>
            }
          />
          <Route
            path="/event-experience-hub"
            element={
              <PrivateRoute requiredRole="volunteer">
                <EventExperienceHub />
              </PrivateRoute>
            }
          />
          <Route
            path="/skills-development-academy"
            element={
              <PrivateRoute requiredRole="volunteer">
                <SkillsDevelopmentAcademy />
              </PrivateRoute>
            }
          />

          {/* Other Routes */}
          <Route path="/smart-opportunity-finder" element={<SmartOpportunityFinder />} />
          <Route path="/organization-impact-profiles" element={<OrganizationImpactProfiles />} />

          {/* Fallback */}
          <Route path="*" element={<NotFound />} />
        </RouterRoutes>
      </ErrorBoundary>
    </BrowserRouter>
  );
};

export default Routes;
